import t from"react";import{mdiViewList as i}from"@mdi/js";import{MdIcon as e}from"./MdIcon.js";const o=({id:o="list-view",title:r="List view",...m})=>t.createElement(e,{path:i,id:o,title:r,...m});export{o as ListViewIcon};
